import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const KVKKPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <Icon name="ArrowLeft" size={24} className="text-gray-600" />
              <span className="font-poppins font-heading-semibold text-lg text-gray-900">
                Geri Dön
              </span>
            </Link>
            <h1 className="font-poppins font-heading-bold text-2xl text-gray-900">
              KVKK Aydınlatma Metni
            </h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600">
              <strong>Son Güncelleme:</strong> 15 Ocak 2024
            </p>
          </div>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              1. Veri Sorumlusu
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, 
              Cafe Otomasyonu olarak veri sorumlusu sıfatıyla, kişisel verilerinizin 
              işlenmesi konusunda aşağıdaki açıklamaları yapmaktayız.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>Veri Sorumlusu:</strong> Cafe Otomasyonu<br />
                <strong>Adres:</strong> Azmimilli Mahallesi. Şafak Sokak. No:37B. 81020, Merkez/DÜZCE<br />
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>Telefon:</strong> +90 507 588 04 81
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              2. Kişisel Verilerin İşlenme Amaçları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-blue-900 mb-3">
                  🎯 Hizmet Sağlama
                </h4>
                <ul className="list-disc pl-6 text-blue-800">
                  <li>QR menü sistemi sunumu</li>
                  <li>Online sipariş platformu</li>
                  <li>POS sistemi hizmetleri</li>
                  <li>Kurye takip sistemi</li>
                  <li>AI analitik araçları</li>
                </ul>
              </div>
              
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-green-900 mb-3">
                  📞 İletişim
                </h4>
                <ul className="list-disc pl-6 text-green-800">
                  <li>Müşteri desteği</li>
                  <li>Teknik yardım</li>
                  <li>Bilgilendirme mesajları</li>
                  <li>Güncelleme bildirimleri</li>
                </ul>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-purple-900 mb-3">
                  🔒 Güvenlik
                </h4>
                <ul className="list-disc pl-6 text-purple-800">
                  <li>Kimlik doğrulama</li>
                  <li>Dolandırıcılık önleme</li>
                  <li>Güvenlik denetimleri</li>
                  <li>Yasal yükümlülükler</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-orange-900 mb-3">
                  📊 Analitik
                </h4>
                <ul className="list-disc pl-6 text-orange-800">
                  <li>Hizmet iyileştirme</li>
                  <li>Performans analizi</li>
                  <li>Kullanım istatistikleri</li>
                  <li>Pazarlama araştırması</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              3. İşlenen Kişisel Veri Kategorileri
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-4 py-2 text-left">Veri Kategorisi</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Örnekler</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">İşlenme Amacı</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Kimlik Bilgileri</td>
                    <td className="border border-gray-300 px-4 py-2">Ad, soyad, TC kimlik no</td>
                    <td className="border border-gray-300 px-4 py-2">Hesap oluşturma, kimlik doğrulama</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">İletişim Bilgileri</td>
                    <td className="border border-gray-300 px-4 py-2">E-posta, telefon, adres</td>
                    <td className="border border-gray-300 px-4 py-2">İletişim, hizmet sunumu</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">İşletme Bilgileri</td>
                    <td className="border border-gray-300 px-4 py-2">İşletme adı, vergi no, sektör</td>
                    <td className="border border-gray-300 px-4 py-2">Hizmet özelleştirme</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Finansal Bilgiler</td>
                    <td className="border border-gray-300 px-4 py-2">Ödeme bilgileri, fatura bilgileri</td>
                    <td className="border border-gray-300 px-4 py-2">Ödeme işlemleri, faturalama</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">İşlem Güvenliği</td>
                    <td className="border border-gray-300 px-4 py-2">IP adresi, cihaz bilgileri</td>
                    <td className="border border-gray-300 px-4 py-2">Güvenlik, dolandırıcılık önleme</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">İşlem Geçmişi</td>
                    <td className="border border-gray-300 px-4 py-2">Siparişler, kullanım logları</td>
                    <td className="border border-gray-300 px-4 py-2">Hizmet sunumu, analitik</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              4. Kişisel Verilerin Aktarılması
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz aşağıdaki durumlarda üçüncü taraflarla paylaşılabilir:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-gray-200 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                  Hizmet Sağlayıcılar
                </h4>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Bulut hizmet sağlayıcıları</li>
                  <li>Ödeme işlemcileri</li>
                  <li>E-posta servisleri</li>
                  <li>Analitik araçları</li>
                </ul>
              </div>
              
              <div className="border border-gray-200 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                  Yasal Zorunluluklar
                </h4>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Mahkeme kararları</li>
                  <li>Kamu kurumları</li>
                  <li>Denetim yetkileri</li>
                  <li>Yasal yükümlülükler</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              5. Kişisel Verilerin Toplanma Yöntemi
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                  Doğrudan Toplama
                </h4>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Web sitesi formları</li>
                  <li>Mobil uygulama</li>
                  <li>E-posta iletişimi</li>
                  <li>Telefon görüşmeleri</li>
                </ul>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                  Otomatik Toplama
                </h4>
                <ul className="list-disc pl-6 text-gray-700">
                  <li>Çerezler ve benzer teknolojiler</li>
                  <li>Sunucu logları</li>
                  <li>Analitik araçları</li>
                  <li>Güvenlik sistemleri</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              6. KVKK Kapsamındaki Haklarınız
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-blue-900 mb-3">
                  Bilgi Alma Hakları
                </h4>
                <ul className="list-disc pl-6 text-blue-800">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>İşlenen kişisel verileriniz hakkında bilgi talep etme</li>
                  <li>Kişisel verilerinizin işlenme amacını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                </ul>
              </div>
              
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-green-900 mb-3">
                  Müdahale Hakları
                </h4>
                <ul className="list-disc pl-6 text-green-800">
                  <li>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme</li>
                  <li>KVKK'da öngörülen şartlar çerçevesinde silinmesini isteme</li>
                  <li>İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişiliğiniz aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
                  <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              7. Haklarınızı Nasıl Kullanabilirsiniz?
            </h2>
            <div className="bg-yellow-50 border border-yellow-200 p-6 rounded-lg mb-6">
              <h3 className="font-poppins font-heading-semibold text-lg text-yellow-900 mb-3">
                📝 Başvuru Yöntemleri
              </h3>
              <p className="text-yellow-800 leading-relaxed mb-4">
                KVKK kapsamındaki haklarınızı kullanmak için aşağıdaki yöntemlerden birini kullanabilirsiniz:
              </p>
              <ul className="list-disc pl-6 text-yellow-800">
                <li><strong>E-posta:</strong> info@cafeotomasyonu.com</li>
                <li><strong>Posta:</strong> Azmimilli Mahallesi. Şafak Sokak. No:37B. 81020, Merkez/DÜZCE</li>
                <li><strong>Telefon:</strong> +90 507 588 04 81</li>
              </ul>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-3">
                Başvuru Formu
              </h4>
              <p className="text-gray-700 leading-relaxed mb-4">
                Başvurunuzu yaparken aşağıdaki bilgileri içeren bir form kullanabilirsiniz:
              </p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Ad, soyad ve başvuru yapanın imzası</li>
                <li>TC kimlik numarası (yabancı ise uyruk, pasaport numarası)</li>
                <li>Tebligat adresi</li>
                <li>Varsa bildirime konu e-posta adresi</li>
                <li>Talep konusu</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              8. Başvuru Süreci
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">1</span>
                </div>
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-2">
                  Başvuru
                </h4>
                <p className="text-gray-700 text-sm">
                  KVKK haklarınızı kullanmak için başvurunuzu yapın
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">2</span>
                </div>
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-2">
                  İnceleme
                </h4>
                <p className="text-gray-700 text-sm">
                  Başvurunuz 30 gün içinde incelenir ve değerlendirilir
                </p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold">3</span>
                </div>
                <h4 className="font-poppins font-heading-semibold text-lg text-gray-900 mb-2">
                  Yanıt
                </h4>
                <p className="text-gray-700 text-sm">
                  Sonuç hakkında yazılı olarak bilgilendirilirsiniz
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              9. Veri Güvenliği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verilerinizin güvenliği için aşağıdaki teknik ve idari tedbirler alınmaktadır:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-blue-900 mb-3">
                  Teknik Tedbirler
                </h4>
                <ul className="list-disc pl-6 text-blue-800">
                  <li>SSL/TLS şifreleme</li>
                  <li>Güvenli veri merkezleri</li>
                  <li>Düzenli güvenlik denetimleri</li>
                  <li>Erişim kontrolü</li>
                  <li>Veri yedekleme</li>
                </ul>
              </div>
              
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="font-poppins font-heading-semibold text-lg text-green-900 mb-3">
                  İdari Tedbirler
                </h4>
                <ul className="list-disc pl-6 text-green-800">
                  <li>Personel eğitimleri</li>
                  <li>Gizlilik sözleşmeleri</li>
                  <li>Veri işleme politikaları</li>
                  <li>Düzenli denetimler</li>
                  <li>Olay müdahale planları</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              10. İletişim
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK kapsamındaki haklarınız ve kişisel verilerinizin işlenmesi hakkında sorularınız için:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>Telefon:</strong> +90 507 588 04 81<br />
                <strong>Adres:</strong> Azmimilli Mahallesi. Şafak Sokak. No:37B. 81020, Merkez/DÜZCE
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              11. Güncellemeler
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Bu KVKK Aydınlatma Metni zaman zaman güncellenebilir. Önemli değişiklikler 
              olduğunda web sitemizde duyurulur ve gerekli durumlarda e-posta ile bilgilendirme yapılır.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default KVKKPage; 